<template>
  <div class="d-bar">
    <template v-if="currentProject.length > 0">
      <div class="container-xl">
        <div class="row justify-content-start">
          <div class="col-4">
            <button class="btn btn-outline-lcn" @click="goToList">
              Projektübersicht
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>

  <div class="container-xl">
    <div
      class="
        row
        justify-content-center
        align-items-center
        d-none d-sm-none d-md-flex
      "
      :class="{ 'shrink-wrap': getActiveGrp() }"
    >
      <div
        class="col-xl-9 col-md-12"
        :class="{ 'shrink-select': getActiveGrp() }"
      >
        <div class="row text-center">
          <div v-if="!getActiveGrp()">
            <p>{{ t("message.clickGT") }}</p>
          </div>
        </div>
        <div
          v-for="(gtGrp, index) in parsedInlays"
          :key="'selectGrp_' + index"
          @click="slideToGrp(index)"
          :class="{ active: getActiveGrp() == index, shrink: getActiveGrp() }"
          class="grp-selection"
          :style="{
            'background-image': 'url(' + imgURL(index) + ')',
            'background-size': '100%',
          }"
        ></div>
      </div>
    </div>
    <div v-if="getActiveGrp()">
      <div
        class="row justify-content-center d-none d-sm-none d-md-flex gt-wrap"
      >
        <div
          v-for="(gt, index) in filterGtGrp()"
          :key="'gt_' + index"
          class="col-lg-3 col-sm-3 justify-content-center"
          @click="showSelection(gt, index)"
        >
          <glass-taster
            :gt="gt"
            :class="{ 'selected-gt': selectedIndex == index }"
          ></glass-taster>

          <button
            class="btn btn-outline-lcn mt-5"
            v-if="selectedIndex == index"
            @click.stop="selectGT()"
          >
            {{ t("message.selectGT") }}
          </button>
        </div>
      </div>
    </div>
    <div v-if="showOldModels">
      <div
        class="row justify-content-end pt-5 pb-5 d-none d-sm-none d-md-flex"
        style="background: white"
      >
        <div class="col-3">
          <button class="btn btn-outline-lcn" @click="newModels = !newModels">
            {{ newModels ? t("message.oldModels") : t("message.newModels") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import GlassTaster from "./GTComponentSelect.vue";
import { currentProject } from "../store/getters";
export default {
  components: {
    GlassTaster,
  },
  setup() {
    const store = useStore();
    const currentlyActiveGT = reactive({});
    const currentlyActiveGtGrp = ref("");
    const parsedInlays = computed(() => store.getters.parsedInlays);
    const selectedIndex = ref(null);
    const currentProject = computed(() => store.getters.currentProject);
    const newModels = ref(true);
    const showOldModels = ref(false);
    const router = useRouter();
    const { t } = useI18n();
    function imgURL(img) {
      return process.env.BASE_URL + "images/gt/" + img.toUpperCase() + ".png";
    }

    function getActiveGrp() {
      return currentlyActiveGtGrp.value;
    }
    //same function as onSlideChange but this time it's not triggered by Swiper Event but we trigger it
    function slideToGrp(grp) {
      currentlyActiveGtGrp.value = grp;
      selectedIndex.value = null;
      newModels.value = true;
    }

    //Selects currently visible GT and makes it available for the editor and routes the user to the editor view
    function selectGT() {
      //In case the currently selected GT is the first overall
      if (!currentlyActiveGT.value) {
        currentlyActiveGT.value =
          parsedInlays.value[currentlyActiveGtGrp.value][0];
      }
      store.commit("setCurrentInlayIndex", currentProject.value.length);
      store.dispatch("setCurrentInlay", currentlyActiveGT.value);
      store.dispatch("addInlayToProject", currentlyActiveGT.value);
      store.dispatch("saveInlay");
      router.push("/editor");
    }
    function goToList() {
      router.push("/list");
    }
    function showSelection(gt, index) {
      if (currentlyActiveGT.value) {
        if (
          currentlyActiveGT.value.name == gt.name &&
          selectedIndex.value == index
        )
          selectGT();
      }

      currentlyActiveGT.value = gt;
      selectedIndex.value = index;
    }
    function filterGtGrp() {
      if (
        (currentlyActiveGtGrp.value.includes("gt6") &&
          !currentlyActiveGtGrp.value.includes("gt6l")) ||
        (currentlyActiveGtGrp.value.includes("gt2") &&
          !currentlyActiveGtGrp.value.includes("gt2t")) ||
        currentlyActiveGtGrp.value.includes("gt12") ||
        currentlyActiveGtGrp.value.includes("gt10")
      ) {
        if (newModels.value) {
          let filteredInlays = parsedInlays.value[
            currentlyActiveGtGrp.value
          ].filter((inlay) => inlay.name.includes("2013"));
          showOldModels.value = true;
          return filteredInlays;
        } else
          return parsedInlays.value[currentlyActiveGtGrp.value].filter(
            (inlay) => !inlay.name.includes("2013")
          );
      } else {
        showOldModels.value = false;
        return parsedInlays.value[currentlyActiveGtGrp.value];
      }
    }
    function selectGTModel(grp) {
      currentlyActiveGtGrp.value = grp;
      selectedIndex.value = null;
    }
    return {
      parsedInlays,
      slideToGrp,
      selectGT,
      selectGTModel,
      getActiveGrp,
      imgURL,
      t,
      currentlyActiveGT,
      currentlyActiveGtGrp,
      currentProject,
      showSelection,
      selectedIndex,
      filterGtGrp,
      newModels,
      showOldModels,
      goToList,
    };
  },
};
</script>

<style lang="scss" scoped>
.gt-btn {
  cursor: move;
}
.d-bar {
  height: 50px;
  padding: 10px;
  background-color: #fff;
  line-height: 30px;
}

.swiper-container {
  height: calc(100vh - 230px);
}

.active {
  font-weight: bold;
  border: 3px solid black;
  transform: scale(1.1);
}
@media (min-resolution: 108dpi) {
  .grp-selection {
    width: 10% !important;
    height: 200px !important;
  }
  .shrink-wrap {
    transform: translate(-0%, -25%);
  }
  .gt-wrap {
    transform: translate(-0%, -10%);
  }
}
.grp-selection {
  cursor: pointer;
  display: inline-block;
  width: 122px;
  height: 220px;
  background-repeat: no-repeat;
  background-position: center;
  margin: 5px;
}
.gt-wrap {
  background: white;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px) scale(50%);
}
.shrink {
  transition: all 0.25s ease-out;
  -webkit-transition: all 0.25s ease-out;
  -moz-transition: all 0.25s ease-out;
  transition-duration: 0.5s;
  transition-property: transform;
}
@media (max-width: 1100px) {
  .shrink-select {
    height: 340px;
    transform: scale(0.6);
  }
  .shrink-wrap {
    // transform: scaleY(0.5);
    height: 250px;
  }
}
@media (min-width: 1101px) {
  .shrink-select {
    height: 10%;
    width: 1100px;
    transform: scale(0.5);
  }
}
.shrink-select {
  transition: all 0.25s ease-out;
  -webkit-transition: all 0.25s ease-out;
  -moz-transition: all 0.25s ease-out;
  transition-duration: 0.5s;

  transition-property: transform;
}
.selected-gt {
  transform: scale(1.15);
  transition-duration: 0.25s;
  transition-property: height;
}
</style>
